import { render } from "./pharaohfrog.vue?vue&type=template&id=175cef40&scoped=true"
import script from "./pharaohfrog.vue?vue&type=script&lang=js"
export * from "./pharaohfrog.vue?vue&type=script&lang=js"

import "./pharaohfrog.vue?vue&type=style&index=0&id=175cef40&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175cef40"]])

export default __exports__